import React from 'react';
import { DateUtils } from '@vectord/utils';
import pluralize from 'pluralize';

import {
  CoursePauseNotePopover,
  LearnerInfoPopover,
} from 'features/courseResume';
import ManageButton from '../ManageButton';
import styles from './ToBeResumedTableRow.module.scss';
import TableCell from 'components/TableCell';
import TableRow from 'components/TableRow';

function ToBeResumedTableRow({ request }) {
  const {
    duration_of_pause: durationOfPause,
    pause_date: pauseDate,
    expected_resume_date: resumeDate,
    meta,
  } = request;
  const { suggested_sb_name: suggestedSuperBatchName } = meta || {};

  return (
    <>
      <TableRow className={styles.root}>
        <TableCell className={styles.rowCell}>
          <LearnerInfoPopover request={request} />
        </TableCell>
        <TableCell className={styles.rowCell}>
          {DateUtils.toDDMMYYYY(pauseDate)}
        </TableCell>
        <TableCell className={styles.rowCell}>
          {pluralize('Month', durationOfPause, true)}
        </TableCell>
        <TableCell className={styles.rowLongCell}>
          {suggestedSuperBatchName || 'N/A'}
        </TableCell>
        <TableCell className={styles.rowCell}>
          {(resumeDate && DateUtils.toDDMMMYYYY(resumeDate)) || 'N/A'}
        </TableCell>
        <TableCell className={styles.noteCell}>
          <CoursePauseNotePopover request={request} />
        </TableCell>
        <TableCell className={styles.actionCell}>
          <ManageButton request={request} />
        </TableCell>
      </TableRow>
    </>
  );
}

export default ToBeResumedTableRow;
